import { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';

import { GlobalService } from './global.service';

import { AXIOS, API, CommonGlobalService, CallbackErrorAxios, CallbackWarningAxios } from '@umanforge/common';
import { SearchApiResponse } from 'interfaces/api_deep_search.interfaces';


export class DeepSearchService {

  static searched(
    search: string, page: number, step: number,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios,
    controller?: AbortController
  ): Promise<SearchApiResponse> {
    return new Promise( async resolve => {
      const config = { ...await CommonGlobalService.getHeaderRequest( token ), params: { search, page, step } };
      if ( controller ) {
        config.signal = controller.signal;
      }
      AXIOS.get( `${API.DEEP_SEARCH}`, config )
        .then( ( response: AxiosResponse<SearchApiResponse> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

};